<template>
  <div class="box mb-2 p-2">
    <div v-for="g in groups" :key="g" class="">
      <p
        v-if="g"
        class="px-2 py-2 bold"
        style="background: #1111; border-radius: 0"
      >
        {{ g }}
      </p>
      <div class="mb-2 d-flex flex-wrap">
        <div
          v-for="c in fields.filter((f) => f.groupId === g)"
          :key="c.id"
          class="p-2"
          :style="{ width: c.width || '100%' }"
        >
          <label>{{ c.name }}</label>
          <div v-if="dataShow">
            <div
              v-if="c.type == 'table'"
              class="table table-bordered table-sm"
              style="overflow: auto"
            >
              <table>
                <thead>
                  <tr>
                    <th
                      v-for="h in c.columns"
                      :key="h.id"
                      style="font-size: 10px; white-space: nowrap"
                      :style="{ width: h.width || 'auto' }"
                    >
                      {{ h.title }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(r, i) in dataShow[c.code]" :key="i">
                    <td v-for="h in c.columns" :key="h.id">
                      {{ r[h.id] || "-" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="c.type == 'image' || c.type == 'file'">
              <img
                v-if="dataShow[c.code]"
                :src="dataShow[c.code]"
                height="200"
              />
              <p v-else>-</p>
            </div>
            <div v-else-if="c.type == 'images' || c.type == 'files'">
              <div v-if="dataShow[c.code] && dataShow[c.code].length">
                <img
                  v-for="(img, index) in dataShow[c.code]"
                  :key="index"
                  :src="img"
                  height="200"
                  class="mr-2 mb-2"
                />
              </div>
            </div>
            <div v-else-if="c.type == 'boolean'">
              <input type="checkbox" disabled :checked="dataShow[c.code]" />
            </div>
            <div v-else-if="c.type == 'date'">
              <p v-if="dataShow[c.code]">
                {{ $formatDate(dataShow[c.code], "DD/MM/YYYY") }}
              </p>
              <p v-else>-</p>
            </div>
            <div v-else-if="c.type == 'date-time'">
              <p v-if="dataShow[c.code]">
                {{ $formatDate(dataShow[c.code], "DD/MM/YYYY HH:mm") }}
              </p>
              <p v-else>-</p>
            </div>
            <div v-else-if="c.type == 'richtext'">
              <div
                v-if="dataShow[c.code]"
                v-html="dataShow[c.code]"
                style="max-height: 300px; overflow: auto"
              ></div>
              <p v-else>-</p>
            </div>
            <div
              v-else-if="
                c.type == 'multi' ||
                c.type == 'multi-select' ||
                c.type == 'multi-search'
              "
            >
              <p>
                {{
                  dataShow[c.code] && Array.isArray(dataShow[c.code])
                    ? dataShow[c.code]
                        .map((item) => $getMultiFieldLabel(item))
                        .filter(Boolean)
                        .join(", ")
                    : "-"
                }}
              </p>
            </div>
            <div v-else>
              <p>{{ dataShow[c.code] || "-" }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash"

export default {
  props: ["data", "name"],

  computed: {
    groups() {
      return _.uniq(this.fields.map((a) => a.groupId)).sort((a, b) => {
        if (!a) return 1
        if (!b) return -1
        return a.localeCompare(b)
      })
    },
    dataShow() {
      const out = {}
      Object.keys(this.data || {}).forEach((k) => {
        // if
        try {
          out[k] = JSON.parse(this.data[k])
          // if (this.data[k] === null) this.$set(this.data, k, "")
        } catch (error) {
          out[k] = this.data[k]
        }
      })
      return out
    },
    fields() {
      return this.$customFields
        .filter((a) => a.tableName == this.name)
        .map((a) => ({
          ...a,
          width: a.type == "table" ? "100%" : a.width || "50%",
        }))
        .sort((a, b) => a.orderId - b.orderId)
    },
  },
}
</script>
